import { useMsal } from "@azure/msal-react";
import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { attendingAPI } from "../../services/userService";
import { clearStorage } from "../../utils/storageUtils";
import AuthContext from "../Auth/Middleware/AuthContext";
import CoderAttendancePop from "../Coder/CoderAttendancePop";
import { userRole } from "../../utils/constants";

const MarkAttendance = () => {
  const authContext = useContext(AuthContext);
  const { instance } = useMsal();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("attending");
    localStorage.removeItem("template");
    authContext.loginAuth(false);
    handleLogoutRedirect();
  };

  const handleLogoutRedirect = () => {
    let account = instance.getActiveAccount();
    clearStorage(account);

    instance.logoutRedirect({
      account: instance.getActiveAccount(),
    });
  };

  const handleRedirection = () => {
    const role = localStorage.getItem("Role");
    if (role === userRole.Manager || role === userRole.TL) {
      navigate("/dashboard");
    } else {
      navigate("/");
    }
  };

  const markIsAttending = (isAttending) => {
    const userId = localStorage.getItem("loginUserId");
    window.localStorage.setItem("attending", isAttending);
    attendingAPI(isAttending, userId);

    if (isAttending) {
      handleRedirection();
    }

    if (!isAttending) {
      handleLogout();
    }
  };

  const isAttending =
    localStorage.getItem("attending") === "true" ? true : false;

  if (isAttending) {
    handleRedirection();
  }

  return (
    <>
      <Modal style={{ marginTop: "4rem" }} show={true} className="welcome">
        <CoderAttendancePop markIsAttending={markIsAttending} />
      </Modal>
    </>
  );
};

export default MarkAttendance;
